export default "__VITE_ASSET__BgvT1bsJ__"